/* eslint-disable require-jsdoc */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */

'use strict';

var detail = require('base/product/detail');
var util = require('../util/util');
var debounce = require('lodash/debounce');
var productBase = require('./base');
var loadingAttributePolyfill = require('loading-attribute-polyfill').default;

/**
 *  true fit update recommended size selection
 */
function truefitSizeUpdate() {
    // Call site-specific hook to select the recommended size
    window.tfcapi('event', 'tfc-fitrec-product', 'autoSizeSelect', function (context) {
        var size = context.size;
        if (size) {
            var productAttributes = $('.product-detail .attributes');
            var sizeAttr = productAttributes.find('[data-attr="size"]');
            var firstWordSize = size.split(' ')[0];
            var pantsSize = size.slice(0, 2);
            if (isNaN(pantsSize)) { // non-jeans size
                sizeAttr.find('.select-size').children('div.attribute-tile').each(function () {
                    if ($(this).children('span').data('attr-display-value').toString()
                        .replace(/ +/g, '') === firstWordSize && !($(this).hasClass('disabled')) && !$(this).hasClass('selected')) {
                        $(this).trigger('click');
                    }
                });
            } else if (!$('.attribute-tiles').find('.selected').length) {
                $('span[data-attr-display-value="' + size + '"]').trigger('click');
            }
        }
    });
}

/**
 * Get cookie value by name
 * @param {string} cookieName - cookie name
 * @returns {string} cookie value
 */
function getCookie(cookieName) { // eslint-disable-line no-unused-vars
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

var exportDetail = $.extend({}, detail, {
    availability: productBase.availability,
    addToCart: productBase.addToCart,
    zoomImageModal: function () {
        var scrollToImage = function (modalObject, index) {
            // calculating position for the top of selected image
            var selectedImagePosition = 0;
            var imageIndex = 0;

            // calculating height of all images above selected
            while (imageIndex < index) {
                selectedImagePosition += modalObject.find("img[data-image-index='" + imageIndex + "']").height();
                imageIndex++;
            }

            modalObject.scrollTop(selectedImagePosition); // scrolling to the selected image
            modalObject.find('.js-pdp-zoom-img').addClass('active'); // show all images after calculating position
        };

        $(document).on('click', '.pdp-image-carousel .carouselItem', function (e) {
            var currentCarousel = $(this);

            // display zoomModal for large viewports only; disable zoomModal for videos
            if (util.mediaBreakpointDown('md') || currentCarousel.hasClass('js-pdp-video')) {
                return;
            }

            e.preventDefault();
            $.spinner().start();

            var url = $('#js-zoom-images-endpoint').val(); // url for ajax call
            var imageIndex = $(this).find('img').attr('data-image-index'); // index of selected image
            var urlParams = {
                pid: $('.js-product-details').data('zoomPid')
            };

            if ($('.product-set-detail').length) {
                urlParams.pid = currentCarousel.data('pid');
            }

            var modal = $('#pdp-zoom-modal'); // modal ID

            modal.find('.js-pdp-zoom-img').removeClass('active'); // hiding all images before calculating correct start position

            if (url) {
                url = util.appendToUrl(url, urlParams); // url for AJAX call

                // loading all images for current product via ajax
                $.get(url, function (data) {
                    modal.find('.modal-body').empty().html(data);

                    var $zoomImages = $('.js-pdp-zoom-imgs').find('noscript.loading-lazy');

                    $zoomImages.each(function () {
                        var $zoomImage = $(this);
                        if ($zoomImage.is('*')) {
                            loadingAttributePolyfill.prepareElement($zoomImage[0]);
                        }
                    });

                    modal.modal('show');
                    modal.on('shown.bs.modal', function () {
                        scrollToImage(modal, imageIndex); // scrolling modal to the top of selected image

                        $.spinner().stop();
                        modal.find('.modal-body').addClass('loaded');
                    });
                });

                // hide modal onClick any image
                modal.on('shown.bs.modal', function () {
                    modal.find('.modal-body').on('click', 'img', function () {
                        modal.modal('hide');
                    });
                });
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var isOrderable = response.product.hasAllVariantSelections && (response.product.readyToOrder || response.product.available);
            var unselectedAttributes = [];
            var $bopisBtn = $('.js-pdp-bopis-btn');
            // eslint-disable-next-line no-undef
            var international = ((window.utag_data && utag_data.int_shipped) || 'US') !== 'US';

            $('.availability-error-message').empty();

            if (!isOrderable) {
                var variantSelections = [];
                response.product.variantSelections.forEach(function (attr) {
                    if (!attr.isSelected) {
                        unselectedAttributes.push(attr.displayName);
                    }
                    variantSelections.push({
                        id: attr.id,
                        isSelected: attr.isSelected,
                        displayName: attr.displayName
                    });
                });
                $('button.add-to-cart').data('variantSelections', variantSelections);
                $('.availability-error-message').hide();
                $('button.add-to-cart').data('isOrderable', false);
            } else {
                $('button.add-to-cart').data('isOrderable', true);
            }

            if (response.product.hasAllVariantSelections && response.product.readyToOrder) {
                $bopisBtn.attr('disabled', false);
                $bopisBtn.data('productId', response.product.id);
                $('.js-bopis-search-btn').data('productId', response.product.id);
            } else {
                $bopisBtn.attr('disabled', true);
            }

            if (response.product.preOrder.status) {
                $('.pdp-store-availability').addClass('d-none');
                $('.js-add-to-cart, .add-to-cart-bar-cta').html('PRE-ORDER');
                if (!international) {
                    $('.pre-order-msg-date').html('Pre-Order now! Estimated shipping date ' + response.product.preOrder.date);
                } else {
                    $('.pre-order-msg-date').html('We are sorry, but this item is out of stock.');
                    $('button.add-to-cart, .add-to-cart-bar-btn button').attr('disabled', true);
                }
                $('.pre-order-msg').show();
                $('#afterpayDynamic').addClass('d-none');
            } else if ($('.pre-order-msg').is(':visible')) {
                $('.pdp-store-availability').removeClass('d-none');
                $('.js-add-to-cart, .add-to-cart-bar-cta').html('ADD TO BAG');
                $('.pre-order-msg').hide();
                $('#afterpayDynamic').removeClass('d-none');
                $('button.add-to-cart, .add-to-cart-bar-btn button').attr('disabled', false);
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);

            // Hide radio buttons for bopis, reset back to standard
            $('.js-pdp-standard').addClass('d-none');
            $('.js-pdp-bopis').addClass('d-none');
            $('.js-pdp-standard-input').click();
        });
    },
    sizeChart: function () {
        // select unit type
        var selectSizeType = function () {
            $('body').on('click', '.unit-type-switcher span', function () {
                var selectedUnitType = $(this).attr('data-unit-type');
                // prevent click on already active button
                if (!$(this).hasClass('active')) {
                    $('.unit-type-switcher span').removeClass('active');
                    // set active class for target unit
                    $(this).addClass('active');
                    // display selected unit tables
                    $('.size-chart').find('[data-units]').fadeOut();
                    $('.size-chart').find('[data-units="' + selectedUnitType + '"]').fadeIn();
                }
            });
        };

        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var modal = $('#sizeChartModal'); // modal ID
            var $prodSizeChart = modal.find('.modal-body');
            var checkTrueFit = $('.product-details-wrapper').find('.tfc-fitrec-product');
            var cloneTrueFit = checkTrueFit.clone().data('styleid', checkTrueFit.attr('id')).removeAttr('id').removeAttr('data-iframeid');

            if ($prodSizeChart.is(':empty')) {
                // get content asset data
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);

                        // display modal
                        modal.modal('show');
                        // check if there is true fit button on the PDP
                        if (checkTrueFit.length && $('.psSizeChart').length) {
                            cloneTrueFit.insertAfter('.psSizeChart h2');

                            if (window.tfcapi) window.tfcapi('calculate');
                        }
                    }
                });
            } else {
                // display modal
                modal.modal('show');
                if (window.tfcapi) window.tfcapi('calculate');
            }
            modal.on('show.bs.modal', function () {
                // init unitChange logic after modal display
                selectSizeType();
                // select first type
                $('.unit-type-switcher span:first').trigger('click');
            });
        });
    },
    updateRecommendedSize: function () {
        // true fit update recommended size selection when choosing color selection
        (function myFunction(i, tries, duration) {
            if (window.tfcapi) {
                truefitSizeUpdate();
                $(document).on('click', '[data-attr="color"] button', function () {
                    setTimeout(function () {
                        truefitSizeUpdate();
                    }, 500);
                });
            } else if (i < tries) {
                setTimeout(function () { myFunction(i + 1, tries); }, duration);
            }
        }(0, 10, 500));
    },
    // TrueFit add to bag event
    trueFitAddtoCart: function () {
        (function myFunction(i, tries, duration) {
            if (window.tfcapi) {
                window.tfcapi('event', 'tfc-fitrec-register', 'addtobag', function (event) {
                    var firstWordSize = event.size.split(' ')[0];
                    var pantsSize = event.size.slice(0, 2);
                    if (isNaN(pantsSize)) { // non jeans size
                        if ($('.attribute-tiles').find('div.selected').length > 0 && $('.attribute-tiles').find('div.selected span').data('attr-display-value').replace(/ +/g, '') === firstWordSize) { $('body').find('button.add-to-cart').trigger('click'); }
                    } else { // jeans size
                        var $swatch = $('.attribute-tile.selected').find('span[data-attr-display-value="' + event.size + '"]');
                        if ($swatch.parent().hasClass('selected')) { $('body').find('button.add-to-cart').trigger('click'); }
                    }
                });
            } else if (i < tries) {
                setTimeout(function () { myFunction(i + 1, tries); }, duration);
            }
        }(0, 10, 500));
    },
    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');
            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .tab-content .content')
                    .empty()
                    .html(data.shortDescription);
            }
        });
    },
    initSizeSelects: function () {
        var maxWidth = 0;
        var $sizeSwatches = $('.select-size').find('.attribute-tile');
        $sizeSwatches.each(function () {
            if ($(this).outerWidth() > maxWidth) { maxWidth = $(this).outerWidth(); }
        });
        $sizeSwatches.css('width', maxWidth);
    },
    initShipDesc: function () {
        var shipContainer = $('.js-ship-desc');
        var obj = JSON.parse($('#pdpShipJson').html() || '{}');
        // eslint-disable-next-line no-undef
        var currentCounty = (window.utag_data && utag_data.int_shipped) || 'US';
        if (obj[currentCounty]) {
            shipContainer.removeClass('d-none').find('.shipping-info').prepend('<p>' + obj[currentCounty] + '</p>');
        }
    },
    getStoreAvailability: function () {
        var that = this;
        $('body').on('click', '.js-pdp-bopis-modal-trigger', function (e) {
            e.preventDefault();
            var $atcBtn = $('button.add-to-cart');
            var unselectedAttributes = [];
            var variantSelections = $atcBtn.data('variantSelections') || [];

            if (!$atcBtn.data('isOrderable')) {
                variantSelections.forEach(function (variant) {
                    if (!variant.isSelected) {
                        unselectedAttributes.push(variant.displayName);
                    }
                });

                $('.availability-error-message').html('Please Select A ' + unselectedAttributes.join(','));
                return;
            }

            var $bopisBtn = $('.js-pdp-bopis-btn');
            var data = {
                pid: $bopisBtn.data('productId')
            };
            if (window.sessionStorage) {
                var postalCode = sessionStorage.getItem('StorePostalCode');
                if (postalCode) data.postalCode = postalCode;
            }

            $.ajax({
                url: $bopisBtn.data('action-modal'),
                data: data
            }).done(function (response) {
                $('.js-bopis-modal-content').html(response);
                $('.js-bopis-modal').modal('show');
                that.bopisChangeStore();
            });
        });
    },
    searchNearbyStores: function () {
        $('body').on('click', '.js-bopis-nearby-btn', function (e) {
            e.preventDefault();

            var $bopisBtn = $('.js-pdp-bopis-btn');
            var $bopisSearchBtn = $(this);

            if (window.sessionStorage) {
                var geoPostalCode = $('.bopis-stores').data('geoPostalCode');
                sessionStorage.setItem('StorePostalCode', geoPostalCode);
            }

            $.ajax({
                url: $bopisSearchBtn.data('action'),
                data: {
                    pid: $bopisBtn.data('productId'),
                    quantity: $('.js-quantity-select').val()
                }
            }).done(function (response) {
                $('.js-bopis-modal-content').html(response);
            });
        });
    },
    searchStores: function () {
        $('body').on('click', '.js-bopis-search-btn', function (e) {
            e.preventDefault();

            var $bopisSearchBtn = $(this);
            if (window.sessionStorage) sessionStorage.setItem('StorePostalCode', $('.js-bopis-search-zip').val());
            $.ajax({
                url: $bopisSearchBtn.data('action'),
                data: {
                    pid: $bopisSearchBtn.data('productId'),
                    quantity: $('.js-quantity-select').val(),
                    postalCode: $('.js-bopis-search-zip').val(),
                    maxDistance: $('.js-bopis-search-range').val()
                }
            }).done(function (response) {
                $('.js-bopis-modal-content').html(response);
            });
        });
    },
    bopisAddToCart: function () {
        $('body').on('click', '.js-pdp-bopis-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var selectedOptions = {
                product_id: $(this).data('pid'),
                pname: $(this).data('pname'),
                brand: $(this).data('brand'),
                price: $(this).data('price'),
                Quantity: $(this).data('quantity'),
                category: $(this).data('category'),
                product_color: $(this).data('product_color'),
                bopis: 'yes',
                discount: $(this).data('discount'),
                product_sku: $(this).data('product_sku'),
                markdown_type: undefined,
                product_dept: $(this).data('product_department'),
                product_division: $(this).data('product_division'),
                product_subdept: $(this).data('product_subdepartment'),
                order_type: 'standard order'
            };


            var storeNumber = $('.js-bopis-store-info').data('store-id');
            if (!storeNumber) {
                $this.next('.js-store-unselected-error').fadeIn().delay(3000).fadeOut();
            } else {
                var form = {
                    storeNumber: storeNumber,
                    pid: $this.data('productId'),
                    quantity: 1
                };
                if ($(this).data('flag')) form.flag = $(this).data('flag').replace('$', (form.pid + '').substring(2, 5));
                $.spinner().start();
                $.ajax({
                    url: $this.data('action'),
                    type: 'post',
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        productBase.methods.handlePostCartAdd(data);
                        selectedOptions.discount = data.productAdded ? data.productAdded.getDiscount : '';
                        selectedOptions.price = data.productAdded ? data.productAdded.price.sales.formatted : '';
                        selectedOptions.product_sku = data.productAdded ? data.productAdded.id : '';
                        selectedOptions.category = data.productAdded ? data.productAdded.primaryCategory : '';
                        selectedOptions.product_color = data.productAdded && data.productAdded.variationAttributes.length > 1 ? data.productAdded.variationAttributes[1].displayValue : '';
                        $('body').trigger('event:AddToCart', selectedOptions);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    bopisChangeStore: function () {
        $('body').off('click', '.js-bopis-atc-btn').on('click', '.js-bopis-atc-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var storeNumber = $this.data('storeId');
            var promoMsg = $('.js-pdp-bopis-btn').data('promoMsg');
            $.spinner().start();
            $.ajax({
                url: $this.data('action'),
                data: {
                    storeNumber: storeNumber,
                    promoMsg: promoMsg
                }
            }).done(function (response) {
                $('.js-bopis-store-info').replaceWith(response);
                $.spinner().stop();
                $('.js-bopis-modal').modal('hide');

                if ($this.hasClass('js-bopis-atc-btn')) $('.js-pdp-bopis-input').click();

                $('.js-pdp-standard').removeClass('d-none');
                $('.js-pdp-bopis').removeClass('d-none');
            });
        });
    },
    updateZoomPID: function () {
        $('body').on('product:variantChanged', function (e, response) {
            $('.js-product-details').data('zoomPid', response.product.id);
        });
    },
    initLazyLoadImages: function () {
        $('body').on('product:afterAttributeSelect', function () {
            var $pdpImages = $('.js-image-carousel-images .carouselItem');
            $pdpImages.each(function () {
                var $pdpImage = $(this).find('noscript.loading-lazy');
                if ($pdpImage.is('*')) {
                    loadingAttributePolyfill.prepareElement($pdpImage[0]);
                }
            });
        });
    },
    // set up quantity stepper
    quantityPicker: function () {
        $('.stepper-minus').on('click', function () {
            var $stepper = $(this).closest('.stepper').find('input');
            var min = $(this).closest('.stepper').find('input').attr('min');
            if (parseInt($stepper.val(), 10) > min) {
                $stepper.val(parseInt($stepper.val(), 10) - 1);
                $('.stepper-plus').prop('disabled', false);
                if (!(parseInt($stepper.val(), 10) > min)) {
                    $(this).prop('disabled', true);
                }
            }
            $(this).closest('.quantity-stepper').siblings('.js-add-to-cart').data('quantity', $stepper.val());
        });
        $('.stepper-plus').on('click', function () {
            var max = $(this).closest('.stepper').find('input').attr('max');
            var $stepper = $(this).closest('.stepper').find('input');
            if (parseInt($stepper.val(), 10) < max) {
                $stepper.val(parseInt($stepper.val(), 10) + 1);
                $('.stepper-minus').prop('disabled', false);
                if (!(parseInt($stepper.val(), 10) < max)) {
                    $(this).prop('disabled', true);
                }
            }
            $(this).closest('.quantity-stepper').siblings('.js-add-to-cart').data('quantity', $stepper.val());
        });
    },
    priorityFulfillment: function () {
        if (document.getElementById('pfCountdown') && window.$ && window.$.fn.countdown) {
            var $pfCountdown = $('#pfCountdown');
            var offset = parseFloat($pfCountdown.data('offset'));
            var holdTo = $pfCountdown.data('endtime').split('-');
            var endtime = new Date(holdTo[0], ((parseFloat(holdTo[1]) - 1) + ''), holdTo[2], holdTo[3], holdTo[4]);
            var layout = '{d<}<li class="list-inline-item mr-4">{dnn}<span class="d-block">DAYS</span></li>{d>}<li class="list-inline-item mr-4">{hnn}<span class="d-block">HOURS</span></li><li class="list-inline-item mr-4">{mnn}<span class="d-block">MINUTES</span></li><li class="list-inline-item mr-4">{snn}<span class="d-block">SECONDS</span></li>';

            $pfCountdown.countdown({
                // eslint-disable-next-line new-cap
                until: $.countdown.UTCDate(offset, endtime),
                layout: layout
            });
        }
    },
    desktopExpandFitSizing: function () {
        if ($(window).innerWidth() > 768 && $('#pane-fit-sizing').attr('data-desktopexpand')) {
            var $this = $('#pane-fit-sizing');
            $this.find('.btn-accordion').removeClass('collapsed');
            $this.find('#collapse-fit-sizing').addClass('show');
        }
    },
    availabilityUpdate: function () {
        var $productContainer = $('#maincontent').children('.product-detail:first()');
        var availabilityJSONString = $('#availabilityJSON').html();
        var availabilityJSON;
        if (availabilityJSONString) {
            availabilityJSON = JSON.parse(availabilityJSONString);
            productBase.methods.updateAttrs(availabilityJSON.product.variationAttributes, $productContainer, availabilityJSON.resources, availabilityJSON.product.notifyMeEnabled);
        }
    },
    stickyAddToCartBar: function () {
        // init sticky addToCart
        var $body = $('body');
        var addToCartBar = $('.add-to-cart-bar');
        var cachedWidth = $(window).width();

        // sticky bar actions
        $body.on('click', '.bar-attributes-label', function () {
            // Open/Close dropdown with attributes
            var targetDropdown = $(this).parent();

            if (!targetDropdown.hasClass('active')) {
                $('.attr-dropdown').parent().removeClass('active');
                targetDropdown.addClass('active');
            } else {
                targetDropdown.removeClass('active');
            }
        }).on('click', '.add-to-cart-bar-btn .btn', function () {
            // init addToCard button click from sticky bar
            $('.cart-and-ipay .add-to-cart').trigger('click');
            $('html, body').animate({ scrollTop: 0 });
        }).on('click', '.notify-me-bar-btn .btn', function () {
            $('.cart-and-ipay .notify-me').trigger('click');
            $('html, body').animate({ scrollTop: 0 });
        });

        // display stickyBar after we scroll our addToCart section with attributes
        var initStickyBar = function () {
            var defaultAddToCart = $('.cart-and-ipay');
            var topBarPosition = addToCartBar.length ? addToCartBar.offset().top : 0;
            var headerHeight = $('header').outerHeight(true);
            var addToCartPosition = defaultAddToCart.length ? defaultAddToCart.offset().top : 0;
            var targetScroll = (addToCartPosition + defaultAddToCart.outerHeight()) - headerHeight;

            if ($(window).scrollTop() > (topBarPosition - headerHeight - defaultAddToCart.outerHeight(true))) {
                addToCartBar.slideUp();
            }

            $(window).off('scroll.atcbar').on('scroll.atcbar', debounce(function () {
                var currentScroll = $(this).scrollTop();
                if (currentScroll > targetScroll) {
                    addToCartBar.slideDown();
                    $('.page').css({
                        'margin-bottom': addToCartBar.outerHeight()
                    });
                } else {
                    addToCartBar.slideUp();
                    $('.page').css({
                        'margin-bottom': 0
                    });
                }
            }, 100));
        };

        // init sticky bar
        initStickyBar();

        util.smartResize(function () {
            var newWidth = $(window).width();
            if (newWidth !== cachedWidth) {
                cachedWidth = newWidth;
                initStickyBar();
            }
        });

        var attributeSelectAction = function () {
            // init click on variationAttribute from stickyBar attribute dropdown
            $body.off('click', '.bar-attribute');
            $body.on('click', '.bar-attribute', function () {
                var targetAttribute = $(this);
                var targetAttributeType = $(this).attr('data-attribute-type');
                var targetAttributeValue = targetAttribute.attr('data-attribute-value');
                targetAttribute.siblings().removeClass('selected');
                targetAttribute.addClass('selected');

                $('div[data-attr=' + targetAttributeType + ']').find('[data-attr-value=' + targetAttributeValue + ']').trigger('click');
            });
        };

        // fill stickyBar colors section with list of Color variations
        var getColorSwatchList = function (attributeData) {
            var attribute = attributeData.find('.color-attribute');
            var attrType = attributeData.attr('data-attr');

            if (attribute.length > 0) {
                addToCartBar.find('.color-attributes').empty();
                if (attribute.find('span.selected').length > 0) {
                    addToCartBar.find('.color-attr-wrapper .value').html('');
                    addToCartBar.find('.color-attr-wrapper .value').text(': ' + attribute.find('span.selected').attr('data-attr-display-value'));
                }

                attribute.each(function () {
                    var colorBackgroundUrl = $(this).find('span').css('backgroundImage').replace(/^url\(['"](.+)['"]\)/, '$1');
                    var colorValue = $(this).attr('aria-describedby');
                    var isSelected = $(this).find('.selected').length > 0 ? ' selected' : '';
                    var isNotifyMe = $(this).find('span').hasClass('is-notify-me') ? ' is-notify-me' : '';

                    addToCartBar.find('.color-attributes').append('<div class="color-swatch-attribute bar-attribute' + isSelected + isNotifyMe + '" data-attribute-value="' + colorValue + '" data-attribute-type="' + attrType + '"><span style="background-image: url(' + colorBackgroundUrl + ')"></span></div>');
                });
                addToCartBar.find('.color-attributes').prepend('<div class="d-block selected-value ">' + addToCartBar.find('.color-attr-wrapper .label').clone().html() + '</div>');
            }
        };

        // fill stickyBar size section with list of Size variations
        var getSizeSwatchList = function (attributeData) {
            var attribute = attributeData.find('.attribute-tile');
            var attributeSelected = attributeData.find('.attribute-tile.selected');
            var attrType = attributeData.attr('data-attr');

            if (attribute.length > 0) {
                addToCartBar.find('.size-attributes').empty();

                if (attributeSelected.length > 0) {
                    addToCartBar.find('.size-attr-wrapper .value').html('');
                    addToCartBar.find('.size-attr-wrapper .value').text(': ' + attributeSelected.find('span').attr('data-attr-display-value'));
                }

                attribute.each(function () {
                    var sizeText = $(this).find('span').text();
                    var sizeValue = $(this).attr('data-attr-value');
                    var isSelected = $(this).hasClass('selected') ? ' selected' : '';
                    var isNotifyMe = $(this).hasClass('is-notify-me') ? ' is-notify-me' : '';
                    var isDisabled = $(this).hasClass('disabled') ? ' disabled' : '';
                    addToCartBar.find('.size-attributes').append('<div class="size-swatch-attribute bar-attribute' + isSelected + isNotifyMe + isDisabled + '" data-attribute-value="' + sizeValue + '" data-attribute-type="' + attrType + '"><span>' + sizeText + '</span></div>');
                });

                addToCartBar.find('.size-attributes').prepend('<div class="d-block selected-value ">' + addToCartBar.find('.size-attr-wrapper .label').clone().html() + '</div>');
            }
        };

        var productAttributes = $('.product-detail .attributes');
        var attributeContainer = productAttributes.find('[data-attr]');
        var colorCode = '';
        var size = '';

        // append variationAttributes into stickyBar
        var loadAttributes = function () {
            // display our sticky bar
            $('.bar-attributes-label').parent().removeClass('active'); // close our block onUpdate filter

            var priceSection = $('.add-to-cart-bar-price'); // add current price to the stickyBar button section
            priceSection.html('').append($('.product-price-rating .price .sales .value').text() + ' - ');

            // loading attributes into stickyBar
            if (attributeContainer.length > 0) {
                addToCartBar.removeClass('d-none');

                attributeContainer.each(function () {
                    var attributeWrapper = $(this);

                    if (attributeWrapper.attr('data-attr') === 'color') {
                        getColorSwatchList(attributeWrapper);
                    }
                    if (attributeWrapper.attr('data-attr') === 'size') {
                        getSizeSwatchList(attributeWrapper);
                    }

                    attributeSelectAction();
                });
            }
        };

        var truefitProductUpdate = function () {
            var colorAttr = productAttributes.find('[data-attr="color"]');
            var sizeAttr = productAttributes.find('[data-attr="size"]');
            var index = 0;
            var pdpSize = '';

            colorCode = colorAttr.find('.selected-attribute').text() !== '' ? colorAttr.find('.selected-attribute').text() : $('body').find('.tfc-fitrec-product').data('colorid');

            sizeAttr.find('.select-size').children('div.attribute-tile').each(function () {
                var attributeWrapper = $(this);
                pdpSize = attributeWrapper.children('span').attr('data-attr-display-value');
                if (index === 0 && !(attributeWrapper.hasClass('disabled'))) {
                    if (isNaN(pdpSize.slice(0, 2))) {
                        size = pdpSize + ' SIZE';
                    } else {
                        size = pdpSize;
                    }
                    index++;
                } else if (!(attributeWrapper.hasClass('disabled'))) {
                    if (isNaN(pdpSize.slice(0, 2))) {
                        size += ':' + pdpSize + ' SIZE';
                    } else {
                        size += ':' + pdpSize;
                    }
                    index++;
                }
            });
            // if (colorCode !== '')
            $('.tfc-fitrec-product').attr('data-colorid', colorCode);
            $('.tfc-fitrec-product').attr('data-availablesizes', size);
        };

        loadAttributes();

        $body.on('product:statusUpdate', function () {
            // reload stickyBar on productUpdate
            loadAttributes();
            truefitProductUpdate();
        });
    },
    yotpoWriteFirstReview: function () {
        $('body').on('click', 'a.write-review-btn-hidden', function () {
            $('button.write-review-button').trigger('click');
            setTimeout(function () {
                var writeForm = document.getElementsByClassName('write-form');
                writeForm[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 500);
        });

        $('body').on('click', '.yotpo-stars', function () {
            if ($(this).siblings('.write-review-btn-hidden').length) {
                $('button.write-review-button').trigger('click');
                setTimeout(function () {
                    var writeForm = document.getElementsByClassName('write-form');
                    writeForm[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 500);
            }
        });
    },
    submitLoyaltyReview: function () {
        var send = window.XMLHttpRequest.prototype.send;
        function sendReplacement(data) {
            if (this.onreadystatechange) {
                this._onreadystatechange = this.onreadystatechange;
            }
            this.onreadystatechange = onReadyStateChangeReplacement;
            return send.apply(this, arguments);
        }

        function onReadyStateChangeReplacement() {
            if (window.utag_data && window.utag_data.s256 && this.responseURL === 'https://api.yotpo.com/v1/widget/reviews' && this.readyState === this.DONE && this.status === 200 && JSON.parse(this.responseText).message === 'ok') {
                $.ajax({
                    url: $('#yotpo-reviews-top-div').data('rewards-url'),
                    type: 'post',
                    data: {
                        customerNo: window.utag_data.customer_no,
                        productId: window.utag_data.product_id[0]
                    }
                });
            }

            if (this._onreadystatechange) {
                return this._onreadystatechange.apply(this, arguments);
            }
        }
        window.XMLHttpRequest.prototype.send = sendReplacement;
    },
    zylerDesktop: function () {
        function moveButton() {
            var firstImage = $('.pdp-image-carousel').find('.carouselItem[data-slick-index="0"]');
            var secondImage = $('.pdp-image-carousel').find('.js-pdp-video').length > 0 ? $('.pdp-image-carousel .carouselItem').eq(2) : $('.pdp-image-carousel .carouselItem').eq(1);

            if ($(window).innerWidth() < 991) {
                if (firstImage.find('.pdpZyler').length < 1) {
                    $('.pdp-image-carousel').find('.pdpZyler').insertAfter(firstImage.find('img'));
                }
            } else if (secondImage.find('.pdpZyler').length < 1) {
                $('.pdp-image-carousel').find('.pdpZyler').insertAfter(secondImage.find('img'));
            }
        }
        moveButton();

        $(window).resize(function () {
            moveButton();
        });
    },
    fireworkCSS: function () {
        // Get the shadow host. Hide if no video for firework videos on PDP
        document.addEventListener('fw:embed-feed:content-ready', function () {
            var host = document.querySelector('fw-embed-feed');
            if (host && host.shadowRoot) {
                var div = host.shadowRoot.querySelector('.fwn-grid');
                if (div) {
                    $('#fireworkVideo').removeClass('d-none');
                    div.style.padding = '0.5rem 0 0';
                }
            }
        });
        document.addEventListener('fw:embed-feed:thumbnail-load', function () {
            var host = document.querySelector('fw-embed-feed');
            var $shadow = $(host.shadowRoot);
            if ($shadow.find('.fwn-1uklz8p').children().length === 1) {
                $shadow.find('.fwn-1xkflbb').css('text-transform', 'lowercase');
                $shadow.find('button.fwn-tif16v').css('border-radius', '0px');
            } else if ($shadow.find('.fwn-1uklz8p').children().length === 2) {
                $shadow.find('.cy-scroll-right').hide();
            }
        });
    }
});

module.exports = exportDetail;
